module.exports = __webpack_public_path__ + "img/Antrian.660cc950.svg";